import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';
import ScreenshotReader from './components/ocr/ScreenshotReader';
import AssistantWidget from './components/assistant/AssistantWidget';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ScreenshotImportPage() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [saving, setSaving] = useState(false);
  const [result, setResult] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    fetch(`${API}/api/auth/me`, { credentials: 'include' }).then((r) => (r.ok ? setReady(true) : navigate('/login')));
  }, [navigate]);

  const save = async (company, rows) => {
    setSaving(true);
    setErr('');
    try {
      const res = await fetch(`${API}/api/ocr/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ company, rows: rows.map((r) => ({ barcode: r.match_barcode, price: r.price, title: r.match_title || r.extracted_title })) }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Could not save.');
      setResult(data);
    } catch (e) {
      setErr(e.message);
    } finally {
      setSaving(false);
    }
  };

  if (!ready) return <div className="min-h-screen bg-zinc-950" />;
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-200">
      <main className="max-w-3xl mx-auto px-4 py-8">
        <button onClick={() => navigate('/dashboard')} className="flex items-center gap-1 text-sm text-zinc-400 hover:text-white mb-6" data-testid="ocr-back-btn">
          <ArrowLeft className="w-4 h-4" /> Dashboard
        </button>
        <h1 className="text-3xl sm:text-4xl font-black text-white mb-2">Basket screenshot import</h1>
        <p className="text-sm text-zinc-400 mb-6">Upload screenshots of your MusicMagpie, WeBuyBooks or World of Books basket. We read every line, match it to your library and refresh those prices.</p>
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-5">
          {result ? (
            <div className="text-center py-6" data-testid="ocr-save-result">
              <CheckCircle2 className="w-10 h-10 mx-auto text-[#00D26A] mb-2" />
              <p className="text-white font-bold">{result.rows_written} {result.rows_written === 1 ? 'price' : 'prices'} refreshed</p>
              {result.skipped_verified > 0 && <p className="text-xs text-zinc-400 mt-1" data-testid="ocr-save-skipped">{result.skipped_verified} kept as-is (already verified)</p>}
              <button onClick={() => setResult(null)} className="mt-4 px-4 py-2 rounded-full text-sm font-bold border border-zinc-700 hover:bg-zinc-800" data-testid="ocr-import-another-btn">
                Import another basket
              </button>
            </div>
          ) : (
            <ScreenshotReader onConfirm={save} confirmLabel="Save prices" busy={saving} />
          )}
          {err && <p className="text-sm mt-3" style={{ color: '#E04A3F' }} data-testid="ocr-save-error">{err}</p>}
        </div>
      </main>
      <AssistantWidget />
    </div>
  );
}
